import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { getArchiveTeamList, getArchiveTeamListWithoutDelay, getTeamMembers } from 'features/teamlist/store/actions'
import { getArchiveListGroupedByDay, getLastSortKey } from 'features/teamlist/store/selectors'
import { openPanel } from 'features/taskPanel/store/actions'
import {
  updateTaskPartiallyById,
  updateTask,
  toggleCompleteTaskRequest,
  patchTaskRequest
} from 'features/task/store/actions'
import { findById } from 'features/list/utils'
import { constants, utils } from 'gipsy-misc'

import qs from 'qs'

const mapStateToProps = state => ({
  completedTasks: getArchiveListGroupedByDay(state),
  lastSortKey: getLastSortKey(state),
  activeTeamMember: state.teamlist.activeTeamMember
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      findById,
      getArchiveTeamList,
      getArchiveTeamListWithoutDelay,
      getTeamMembers,
      openPanel,
      updateTaskPartiallyById,
      updateTask,
      toggleCompleteTaskRequest,
      patchTaskRequest
    },
    dispatch
  )
})

export default function wrapper(Component) {
  class ArchiveTeamPageContainer extends PureComponent {
    lastSortKey = ''
    constructor(props) {
      super(props)

      const queryParams = qs.parse(this.props.location.search, { ignoreQueryPrefix: true })
      if (queryParams.open) {
        this.props.actions.openPanel(queryParams.open)
      }

      this.load()
    }

    load = async () => {
      if (this.props.activeTeamMember) {
        await this.props.actions.getArchiveTeamListWithoutDelay(
          this.props.activeTeamMember,
          '',
          constants.limitPaginationArchive
        )
      }
      this.didLoad = true
    }

    componentDidUpdate(prevProps) {
      if (this.props.activeTeamMember !== prevProps.activeTeamMember) {
        this.load()
      }
    }

    onComplete = ({ id, paramName, value }) => {
      this.props.actions.updateTaskPartiallyById(id, { [paramName]: value })
      this.props.actions.toggleCompleteTaskRequest(id, value)
    }

    patchers = {}

    onChange = (taskId, { paramName, value, method = 'change' }) => {
      let task = this.props.actions.findById(taskId)

      const { params, body } = utils.task.computePatchRequest(task, { paramName, value, method })

      let newTask = utils.task.computeTaskOnChange(task, {
        paramName: paramName,
        value: value,
        method: method
      })
      this.props.actions.updateTask(newTask)
      if (!this.patchers[taskId]) {
        this.patchers[taskId] = new utils.TaskPatcher(constants.delayBeforePatch.default)
      }
      return new Promise((resolve, reject) => {
        this.patchers[taskId].put(paramName, method, () => {
          return this.props.actions
            .patchTaskRequest(task.id, params, body)
            .then(args => {
              resolve(args)
            })
            .catch(reject)
        })
      })
    }

    onClick = taskId => {
      this.props.actions.openPanel(taskId)
    }

    onEnterWaypoint = () => {
      const lastSortKey = this.props.lastSortKey
      /* prevent loading archive teamlist pagination when initial fetch hasnt finished yet */
      if (!this.didLoad || !lastSortKey || this.lastSortKey === lastSortKey) {
        return
      }

      this.lastSortKey = lastSortKey
      this.props.actions.getArchiveTeamListWithoutDelay(
        this.props.activeTeamMember,
        lastSortKey,
        constants.limitPaginationArchive
      )
    }

    render() {
      return (
        <Component
          completedTasks={this.props.completedTasks}
          onClick={this.onClick}
          onComplete={this.onComplete}
          onChange={this.onChange}
          lastSortKey={this.props.lastSortKey}
          onEnterWaypoint={this.onEnterWaypoint}
        />
      )
    }
  }

  const containerRedux = connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    {
      pure: true
    }
  )(ArchiveTeamPageContainer)

  return containerRedux
}



// WEBPACK FOOTER //
// ./src/pages/teamlist/archivePage/container.js